import React from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact, gtmEvent } from "higher-order-components"
import { YoutubePlayer, Overlay } from "containers"
import { Heading } from "components"
import { Portal } from "react-portal"
import getVideoId from "get-video-id"
import { gtmFeatureYoutubeActionTypes } from "store/gtm-events"

const PlayIcon = props => (
  <svg style={props.style} viewBox="0 0 40 40">
    <circle r="15" cy="20" cx="20" />
    <path
      d="m17.44771,15.71548l7.80763,4.28452l-7.80763,4.28452l0,-8.56904l0,-0.00001z"
      fill="white"
      strokeWidth="0" />
  </svg>
)

PlayIcon.propTypes = {
  style: PropTypes.object,
  onClick: PropTypes.func
}

export class FeatureYoutube extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      overlayActive: false
    }
  }
  activateOverlay(active) {
    this.setState({ overlayActive: active })
  }
  youtubeId(url) {
    const videoId = getVideoId(url)
    if (videoId) {
      return videoId.id
    }
    return null
  }
  render() {
    // false was this.props.compact -> removed because of SM-617
    const styles = AccessoryItemStyles(false)
    const {
      imageSrc, videoSrc, heading, gtmEvent, CMSGroupGTM, outline
    } = this.props
    return (
      <div style={[styles.base, outline && styles.border]} data-test="accessory-item">
        <div style={styles.coverImg}>
          <div
            style={[
              { width: "100%", height: "100%", position: "relative" },
              styles.accsessoryCoverImg
            ]}
            onClick={() => {
              gtmEvent({
                gtmID: gtmFeatureYoutubeActionTypes.CLICK_PLAY_WATCH_VIDEO,
                gtmPayload: {
                  CMSGroupGTM,
                  isPlay: true,
                  videoName: heading
                }
              })
              this.activateOverlay(true)
            }}>
            <figure
              style={{
                backgroundImage: `url(${imageSrc})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "100%",
                height: "100%",
                margin: 0,
                padding: 0
              }}>
              <img
                src={imageSrc}
                alt={heading}
                style={{ width: "100%", height: "100%", opacity: 0 }} />
            </figure>
          </div>
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none"
            }}>
            <PlayIcon
              style={{
                width: "25%",
                height: "25%",
                fill: "transparent",
                stroke: "white"
              }} />
          </div>
        </div>
        <div style={styles.accessoryDetails}>
          <Heading
            tag="h5"
            value={heading}
            customHeadingStyle={{
              fontSize: "90%"
            }} />
          <div>
            <div style={styles.hr} />
            <div
              key={Math.random()}
              style={styles.readMore}
              onClick={() => {
                gtmEvent({
                  gtmID: gtmFeatureYoutubeActionTypes.CLICK_PLAY_WATCH_VIDEO,
                  gtmPayload: {
                    CMSGroupGTM,
                    isPlay: false,
                    videoName: heading
                  }
                })
                this.activateOverlay(true)
              }}>
              <Heading tag="h5" value="WATCH VIDEO" />
            </div>
          </div>
        </div>
        {this.state.overlayActive && (
          <Portal>
            <Overlay close={() => this.activateOverlay(false)}>
              <div
                className="video-control"
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}>
                <YoutubePlayer videoId={this.youtubeId(videoSrc)} autoPlay />
              </div>
            </Overlay>
          </Portal>
        )}
      </div>
    )
  }
}

export default withRadium(DetectCompact(), gtmEvent())(FeatureYoutube)

FeatureYoutube.propTypes = {
  imageSrc: PropTypes.string,
  videoSrc: PropTypes.string,
  heading: PropTypes.string,
  compact: PropTypes.bool,
  gtmEvent: PropTypes.func,
  CMSGroupGTM: PropTypes.object,
  outline: PropTypes.bool
}

FeatureYoutube.defaultProps = {
  compact: true,
  outline: true
}

const AccessoryItemStyles = compact => ({
  base: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    borderBottomSize: "2px",
    minHeight: "200px",
    flexDirection: compact ? "row" : "column",
    height: !compact && "auto"
  },

  border: {
    border: "1px solid #d5d5d5",
    background: "#fff"
  },

  coverImg: {
    left: "0px",
    top: "0px",
    bottom: "0px",
    overflow: "hidden",
    boxSizing: "border-box",
    position: compact ? "absolute" : "relative",
    width: compact ? "50%" : "100%",
    height: !compact && "200px",
    cursor: "pointer"
  },

  accessoryDetails: {
    padding: "1.5em 1.5em 0.5em",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxSizing: "border-box",
    marginLeft: compact ? "50%" : "0px",
    textAlign: "center",
    width: compact ? "50%" : "100%"
  },

  readMore: {
    fontSize: "90%",
    color: "#aaaaaa",
    transition: ".5s",
    cursor: "pointer",
    display: compact ? "none" : "block",
    ":hover": { color: "black" }
  },

  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1em",
    paddingBottom: "1.3em",
    display: compact ? "none" : "block"
  },

  accsessoryCoverImg: {
    width: "100%",
    transition: "transform 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    ":hover": { transform: "scale(1.05)" },
    ":focus": { transform: "scale(1.05)" }
  }
})



// WEBPACK FOOTER //
// ./src/containers/feature-youtube/index.jsx